// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__DYpc6","choiceBoxes":"toolbarselects_choiceBoxes__p4hOc","simpleField":"toolbarselects_simpleField__1ZVHv"};